export default __webpack_public_path__ + "static/media/upgrade-icon.90fc4486.svg";